import React from 'react'
import { FeatherLoader } from '@abroad/components'
import loadable from '@loadable/component'

const LoadableCategories = loadable(() => import('./CategoriesNotes'), {
  fallback: <FeatherLoader width={60} />,
})

export default LoadableCategories
